import { CommonModule } from "@angular/common";
import { PhxBannerComponent } from "./phx-banner.component";
import { NgModule } from "@angular/core";
import { PhxIconButtonModule } from "../icon-button/phx-icon-button.module";

@NgModule({
    declarations: [
        PhxBannerComponent,
    ],
    imports: [
        CommonModule,
        PhxIconButtonModule,
    ],
    exports: [
        PhxBannerComponent,
    ]
})
export class PhxBannerModule { }